import { IEqualOptimizeResponsesDriver } from 'constants/types';
import clonedeep from 'lodash.clonedeep';
import dayjs from 'dayjs';

export const getDriverSummary = (driver: IEqualOptimizeResponsesDriver) => {
  let filteredDriver = clonedeep(driver);

  // RT-1025 리스트에 휴게시간과 도착지 까지의 정보를 포함하도록 변경 예정
  // filteredDriver.orderList = filteredDriver.orderList.filter(x => x.type === 'order');
  return {
    h: Math.floor(
      Math.floor(
        filteredDriver.orderList
          .map(d => d.route?.internal?.requiredTime ?? 0)
          .reduce((prev, current) => prev + current, 0) / 60
      ) / 60
    ),
    m: Math.floor(
      Math.floor(
        filteredDriver.orderList
          .map(d => d.route?.internal?.requiredTime ?? 0)
          .reduce((prev, current) => prev + current, 0) / 60
      ) % 60
    ),
    d: (
      filteredDriver.orderList
        .map(d => d.route?.internal?.requiredDistance ?? 0)
        .reduce((prev, current) => prev + current, 0) / 1000
    ).toFixed(1),
  };
};

export const getTotalReqTime = ({
  performedDate,
  workStartTime,
  lastOrderETA,
}: {
  performedDate: string;
  workStartTime: string;
  lastOrderETA: string;
}) => {
  const separator = performedDate.replace(/[0-9]/g, '').charAt(0);

  let routeStartTime = dayjs(
    new Date(
      Number(performedDate?.split(separator)[0]),
      Number(performedDate?.split(separator)[1]) - 1,
      Number(performedDate?.split(separator)[2]),
      Number(workStartTime?.split(':')[0]),
      Number(workStartTime?.split(':')[1]),
      0
    )
  ).utcOffset('+0900');

  let totalReqTime = Math.abs(routeStartTime.diff(dayjs(lastOrderETA), 's'));

  return { routeStartTime, totalReqTime };
};

export const getTotalReqTimeSameDate = ({
  performedDate,
  firstOrderETA,
  workStartTime,
  lastOrderETA,
}: {
  performedDate: string;
  firstOrderETA: string;
  workStartTime: string;
  lastOrderETA: string;
}) => {
  let routeStartTime = dayjs(performedDate)
    .set('hour', parseInt(workStartTime?.split(':')[0]))
    .set('minute', parseInt(workStartTime?.split(':')[1]))
    .set('second', 0)
    .utcOffset('+0900');
  if (routeStartTime.isValid()) {
    let totalReqTime = Math.abs(routeStartTime.diff(dayjs(lastOrderETA), 's'));
    if(isNaN(totalReqTime)) return 0;
    return totalReqTime;
  }
  return 0;
};
